import { BarChart3 } from 'lucide-react';

export default function Analytics() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold">Analytics</h1>
        <p className="text-muted-foreground mt-2">
          View detailed analytics and performance metrics
        </p>
      </div>

      <div className="bg-white border border-gray-200 rounded-2xl shadow-lg p-6">
        <div className="text-center py-12">
          <BarChart3 className="w-12 h-12 text-muted-foreground mx-auto mb-4" />
          <h3 className="text-lg font-medium mb-2">Analytics Coming Soon</h3>
          <p className="text-muted-foreground">
            Detailed analytics and performance reports will be available here
          </p>
        </div>
      </div>
    </div>
  );
}
